<template>
  <PageLoader v-if="(loading || isDetailLoading || loadingDestroy) && !missingConfig" />
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
      <template #layoutContent>
        <div v-if="hideContent" class="d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <h3> {{ $t('mail.notConnected') }} </h3>
          <h3> {{ $t('mail.notConnectedDesc') }}</h3>
          <Button type="new" btn-class="btn-md fs-6 my-5" @click.prevent="toggleConfigModal" style="cursor: pointer;" btn-text="auth.login"></Button>
        </div>
        <div v-else class="row mb-8">
          <div class="col-12 col-md-3 col-lg-3">
            <div class="row px-2">
              <Button type="new" btn-class="btn-md fs-6 mb-5" @click.prevent="openMessageComponent" style="cursor: pointer;" btn-text="mail.new_message"></Button>
            </div>
            <FolderPanel
                v-if="folders.length"
                :folders="folders"
                :showSchedule="showSchedule"
                :currentFolder="tab"
                @handle-folder-opened="setTab"
                :on-drop="onDrop"
            />
            <div class="row px-2">
              <button @click.prevent="logoutMail" style="cursor: pointer;" :disabled="loadingLogout" class="btn btn-md btn-light">
                <i class="fas fa-sign-out-alt fs-2 me-3"></i> {{$t('header.logout')}}
              </button>
            </div>
          </div>
          <div class="col-12 col-md-9 col-lg-9">
            <div class="card shadow-sm">
              <MailActionsBar
                  :folders="folders"
                  :all-action="!hideTable"
                  :show-schedule="showSchedule"
                  :is-draft-folder="isDraftFolder"
                  :selected-rows-length="currentRow.length"
                  :loading-reply="loadingReplyAll"
                  :loading-share="loadingTransfer"
                  :loading-edit="loadingUpdate"
                  :loading-destroy="loadingDestroy"
                  :current-mail="currentMail"
                  :set-hide-table="setHideTable"
                  :load-use-search="loadUseSearch"
                  @handleAction="performAction"
                  v-model:filter="query.filter"
                  v-model:search="search"
              />
              <div class="card-body">
                <div v-if="loading" class="content d-flex flex-column flex-column-fluid mb-20" id="kt_content2">
                  <div class="container-xxl">
                    <div class="row loader" style="text-align: center">
                      <div class="spinner">
                      </div>
                      <div>{{ $t('loading') }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="pb-5">
                  <div class="scroll-y" :style="large ? { maxHeight: '100px', overflowY: 'auto' } : {}">
                    <MailDatatable
                        v-if="!hideTable"
                        :current-mail="currentMail"
                        :current-folder="tab"
                        :mails="getMails"
                        :isSendedTab="isSendedTab"
                        :showSchedule="showSchedule"
                        @handle-click-row="detailData"
                        @handle-double-click-row="handleDoubleClick"
                        v-model:sort-by="query.sortBy"
                        v-model:selected-rows="currentRow"
                    />
                  </div>
                  <div class="d-flex align-items-center border-top" :class="showSchedule ? 'justify-content-end' : 'justify-content-between'" style="margin: 0 -25px !important;" v-if="!hideTable && getMails?.length > 0">
                    <MailPaginator
                        v-if="!showSchedule"
                        :current-page="mails.current_page"
                        :per-page="mails.per_page"
                        :last-page="mails.last_page"
                        :total="mails.total"
                        :go-to-first="goToFirstPage"
                        :go-to-last="goToLastPage"
                        :next="goToNextPage"
                        :previous="goToPreviousPage"
                    />
                    <div class="d-flex px-8 py-5">
                      <i class="fas fa-arrow-circle-up fs-2" v-if="!large" :title="$t('mail.enlarge')" @click.prevent="setLarge" style="color: #303D4E; cursor: pointer;"></i>
                      <i class="fas fa-arrow-circle-down fs-2" v-else :title="$t('mail.reduce')" @click.prevent="setLarge" style="color: #303D4E; cursor: pointer;"></i>
                    </div>
                  </div>

                  <div style="margin: 0 -25px !important;" :class="large ? 'border-top' : ''" v-if="Object.values(currentMail).length > 0 && showDetail">
                    <MessageDetail
                        :large="hideTable"
                        :user="currentUser"
                        :schedule="showSchedule"
                        :detailItem="currentMail"
                        :tabName="tabName"
                        :isDetailLoading="isDetailLoading"
                        @handle-action="performAction"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TagMailModal id="tag_mail_modal" :form="formTag" @load="loadData" @edit="getUpdateLoading"/>
        <MessageModal id="reply_message_modal" :form="formReplyData" @load="loadData" @reply="getReplyLoading"/>
        <MessageModal id="reply_all_message_modal" :form="formReplyData" @load="loadData" @reply="getReplyLoading"/>
        <TransferModal id="transfer_message_modal" :form="formReplyData" @load="loadData" @transfer="getLoading"/>
        <UserImapModal id="create_user_imap_modal" :user="currentUser" @load="loadAllData" @finish="showDisplayedContent" @close="hideDisplayedContent"/>
        <UpdateMailModal id="update_mail_modal" :form="formReplyData" @load="loadData" @edit="getUpdateLoading"/>
        <MessagePrintModal id="message_print_modal" :item="currentMail"/>
      </template>
    </SubLayout>
</template>

<script setup>
  import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
  import {useRouter, useRoute} from "vue-router";
  import {useStore} from "vuex";
  import {useLocales} from "@/composables/locales";
  import {useSwal} from "@/composables/useSwal";
  import {computed, ref, watch, onMounted, nextTick} from "vue";
  import { useI18n } from 'vue-i18n'
  import Button from "@/components/Button";
  import MessageModal from "./components/Modals/MessageModal"
  import MessageDetail from "./components/MessageDetail.vue"
  import {$dateFormatterWithDay, subText, $formatDateTime, $formatToYmdHi, formatArray} from "@/mixins/Helpers";
  import TransferModal from "./components/Modals/TransferModal"
  import UserImapModal from "./components/Modals/UserImapModal.vue"
  import UpdateMailModal from "./components/Modals/UpdateMailModal.vue";
  import moment from 'moment';
  import { $openInAnotherWindow } from "@/mixins/Helpers";
  import mailConst from "@/composables/mailConst";
  import TagMailModal from "./components/Modals/TagMailModal.vue";
  import MessagePrintModal from "./components/MessagePrintModal.vue";
  import PageLoader from "@/components/PageLoader.vue";
  import FolderPanel from "@/Modules/Mail/views/Mail/components/FolderPanel.vue";
  import MailDatatable from "@/Modules/Mail/views/Mail/components/MailDatatable.vue";
  import MailPaginator from "@/Modules/Mail/views/Mail/components/MailPaginator.vue";
  import MailActionsBar from "@/Modules/Mail/views/Mail/components/MailActionsBar.vue";
  import {mailActions} from "@/Modules/Mail/views/Mail/composables/mailActions";
  import { debounce } from 'lodash';

  const router = useRouter()
  const route =  useRoute()
  const store = useStore()
  const {locale} = useLocales()
  const { t } = useI18n({ useScope: 'global' })
  const {showSwal} = useSwal()
  
  const title = ref("breadcrumbs.mail.title")
  const breadcrumbs = ref([
    {
      name: 'breadcrumbs.mail.list',
      route: 'mail-index'
    }
  ])
  
  const tab = ref(null)
  const tabName = ref('')
  const large = ref(false)
  const hideTable = ref(false)
  const loading = ref(true)
  const loadingDestroy = ref(false)
  const loadingTransfer = ref(false)
  const loadingReplyAll = ref(false)
  const loadingUpdate = ref(false)
  const loadingLogout = ref(false)
  const isDetailLoading = ref(false)
  const windowMail = ref(null)

  const currentUser = computed(() => store.getters['user/currentUser'])
  const mails = computed(() => store.getters['mails/getMails'])
  const getFolders = computed(() => store.getters['folders/getFolders'])
  const scheduleMails = computed(() => store.getters['mails/getScheduleMails'])
  const showSchedule = computed(() => route.query.tab === 'schedule')
  const isDraftFolder = computed(() => route.query.tab === mailConst.DRAFT)
  const getMails = computed(() => {
    if(showSchedule.value){
      return scheduleMails.value;
    }else{
      return mails.value?.data;
    }
  })
  const currentMail = computed(() => store.getters['mails/getCurrentMail'])


  const folders = ref([])
  const currentRow = ref([])
  const search = ref('')
  const showDetail = ref(false)
  const checkAll = ref(false)
  const missingConfig = ref(false)
  const hideContent = ref(false)

  const formTag = ref({
    uid: "",
    folder: "",
    model_ids: []
  })

  const formReplyData = ref({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    message: '',
    attachments: [],
    email_id: '',
    folder: '',
    priority: '3 (Normal)',
    request_receipt: false,
    attach_files: [],
    removed_attachments: [],
    is_draft: false
  })

  const query = ref({
    sortBy: {
      name: 'from_name',
      sort: 'desc',
    },
    filter: ''
  })

  const draggedMailId = ref('')

  const isSendedTab = computed(() => tabName.value == mailConst.SEND || tabName.value == mailConst.DRAFT)
  const trashFolder = computed(() => tab.value && decodeURIComponent(tab.value) == mailConst.TRASH)
  const draftFolder = computed(() => tab.value && decodeURIComponent(tab.value) == mailConst.DRAFT)
  const activeSignature = computed(() => store.getters['mails/getActiveSignature'])
  const folder = computed(() => {
    if(route.query.tab) return decodeURIComponent(decodeURIComponent(route.query.tab))
    return ''
  })

  const imapConfig = computed(() => store.getters['mails/getImapConfig'])


  watch(() => imapConfig.value, () => {
    if(imapConfig.value.email){
      missingConfig.value = false
      hideContent.value = false
    }
  }, { immediate: true, deep: true });

  watch(() => tab.value, (value) => {
    if(folders.value){
      let folder = findFolderByFolderId(folders.value, decodeURIComponent(value));
      if(folder) {
        tabName.value = folder?.folder_id
      }else{
        if(value == 'schedule'){
          tabName.value = value
        }
      }
      large.value = false
      hideTable.value = false
      router.push({ query: { tab: encodeURI(value) } });
      loadData()
    }
  });

  watch(
      () => search.value,
      debounce(() => {
        loadData();
      }, 300)
  );

  watch(() => query.value.filter, () => {
    loadData()
  })

  watch(() => getFolders.value, (value) => {
    if (value) {
      folders.value = formatFolders(value);

      if(folders.value.length) {
        tab.value = folder.value ? folder.value: folders.value[0].folder_id
      }
    }
  });

  watch(() => mails.value, (value) => {
    if (value) {
      loading.value = false
    }
  });

  watch(() => currentRow.value, (value) => {
    checkAll.value = currentRow.value.length === getMails.value?.length;
    if(currentRow.value.length > 1) {
      showDetail.value = false
      store.commit('mails/RESET_CURRENT_MAIL')
    }
  }, { deep: true });

  watch(() => currentMail.value, (value) => {
    if(!(Object.values(value).length > 0) && large.value) {
      large.value = false
      hideTable.value = false
    }
  }, { deep: true });

  function performAction ({ action, params }) {
    switch (action) {
      case mailActions.REPLAY:
        if(!loadingReplyAll.value){
          loadingReplyAll.value = true
          if(currentRow.value){

            formReplyData.value.email_id = currentMail.value.id
            formReplyData.value.to = [currentMail.value.from.mail]
            formReplyData.value.folder = tabName.value
            formReplyData.value.subject = 'Re: ' + currentMail.value.subject
            formReplyData.value.message = getReplyMessage(currentMail.value)
            formReplyData.value.cc = []
            formReplyData.value.bcc = []
            formReplyData.value.attachments = []

            $('#reply_message_modal').modal('toggle')
          }
        }
        break;
      case mailActions.REPLAY_ALL:
        if(!loadingReplyAll.value){
          loadingReplyAll.value = true
          if(currentRow.value){
            formReplyData.value.email_id = currentMail.value.id
            formReplyData.value.to = [currentMail.value.from.mail]
            formReplyData.value.folder = tabName.value
            formReplyData.value.subject = 'Re: ' + currentMail.value.subject
            formReplyData.value.message = getReplyMessage(currentMail.value)
            formReplyData.value.cc = []
            formReplyData.value.bcc = []
            formReplyData.value.attachments = []

            if(currentMail.value.to) {
              currentMail.value.to.forEach((item) => {
                if(item.mail !== imapConfig.value.email){
                  formReplyData.value.cc.push(item.mail)
                }
              })
            }

            if(currentMail.value.cc) {
              currentMail.value.cc.forEach((item) => {
                if(item.mail !== imapConfig.value.email){
                  formReplyData.value.cc.push(item.mail)
                }
              })
            }

            if(currentMail.value.bcc) {
              currentMail.value.bcc.forEach((item) => {
                if(item.mail !== imapConfig.value.email){
                  formReplyData.value.bcc.push(item.mail)
                }
              })
            }

            $('#reply_all_message_modal').modal('toggle')
          }
        }
        break;
      case mailActions.REFRESH:
        loadData()
        break;
      case mailActions.SHARE:
        if(!loadingTransfer.value){
          loadingTransfer.value = true
          if(currentRow.value){
            formReplyData.value.email_id = currentMail.value.id
            formReplyData.value.to = []
            formReplyData.value.folder = tabName.value
            formReplyData.value.subject = 'Fwd: ' + currentMail.value.subject
            formReplyData.value.message = currentMail.value.body_html
            formReplyData.value.cc = []
            formReplyData.value.bcc = []
            formReplyData.value.attachments = []

            if(currentMail.value.attachments) {
              currentMail.value.attachments.forEach((item) => {
                formReplyData.value.attachments.push(item)
              })
            }

            $('#transfer_message_modal').modal('toggle')
          }
        }
        break;
      case mailActions.EDIT:
        if(!loadingUpdate.value){
          loadingUpdate.value = true
          if(currentMail.value) {

            formReplyData.value.email_id = currentMail.value.id
            const date = moment(currentMail.value.date).format('YYYY-MM-DD HH:mm');

            formReplyData.value.to = []
            formReplyData.value.folder = tabName.value
            formReplyData.value.subject = currentMail.value.subject
            formReplyData.value.message = currentMail.value.body_html
            formReplyData.value.cc = []
            formReplyData.value.bcc = []
            formReplyData.value.scheduled_at = date,
                formReplyData.value.priority = currentMail.value.priority
            formReplyData.value.request_receipt = currentMail.value.request_receipt

            formReplyData.value.attach_files = []

            if(currentMail.value.to){
              currentMail.value.to.forEach((item) => {
                if(item.mail !== currentUser.value.email){
                  formReplyData.value.to.push(item.mail)
                }
              })
            }

            if(currentMail.value.cc) {
              currentMail.value.cc.forEach((item) => {
                if(item.mail !== currentUser.value.email){
                  formReplyData.value.cc.push(item.mail)
                }
              })
            }

            if(currentMail.value.bcc) {
              currentMail.value.bcc.forEach((item) => {
                if(item.mail !== currentUser.value.email){
                  formReplyData.value.bcc.push(item.mail)
                }
              })
            }

            if(currentMail.value.attachments) {
              currentMail.value.attachments.forEach((item, index) => {
                formReplyData.value.attach_files.push({
                  file: item.name,
                  file_url: item.url,
                  type: item.url?.split('.')[1],
                  id: index + 1,
                  size: item.size
                })
              })
            }

            $('#update_mail_modal').modal('toggle')
          }
        }
        break;
      case mailActions.MAKE_READ:
        readMails()
        break;
      case mailActions.MAKE_UNREAD:
        unreadMails()
        break;
      case mailActions.MAKE_IMPORTANT:
        importantMails()
        break
      case mailActions.MAKE_NOT_IMPORTANT:
        notImportantMails()
        break;
      case mailActions.CHANGE_FOLDER:
        changeMailFolder(params.title)
        break;
      case mailActions.PRINT:
        printMail()
        break
      case mailActions.DELETE:
        deleteMail()
        break;
      case mailActions.TAG_PROJECT:
        formTag.value.uid = currentMail.value.id
        formTag.value.folder = folder.value

        $('#tag_mail_modal').modal('toggle')
        break;
    }
  }

  async function resetCurrentMail() {
    store.commit('mails/RESET_CURRENT_MAIL')
  }

  async function readMails() {
    loading.value = true
    await store.dispatch('mails/markAsRead', {email_ids: currentRow.value, folder: tabName.value}).then((res) => {
      // loadMails(mails.value.current_page)
      currentRow.value = []
      // TODO: reset current mail state
      resetCurrentMail()
      window.toastr['success'](t('mail.mark_as_read_successfully'))
      loading.value = false
      store.dispatch('mails/loadUnseenMailCount')
    }).catch(() => loading.value = false)
  }

  async function unreadMails() {
    loading.value = true
    await store.dispatch('mails/markAsUnread', {email_ids: currentRow.value, folder: tabName.value}).then((res) => {
      // loadMails(mails.value.current_page)
      currentRow.value = []
      //TODO: set currentMail state
      resetCurrentMail()
      window.toastr['success'](t('mail.mark_as_unread_successfully'))
      store.dispatch('mails/loadUnseenMailCount')
      loading.value = false
    }).catch(() => loading.value = false)
  }

  async function importantMails() {
    loading.value = true
    await store.dispatch('mails/markAsImportant', {email_ids: currentRow.value, folder: tabName.value}).then((res) => {
      // loadMailData()
      window.toastr['success'](t('mail.mark_as_important_successfully'))
    })
  }

  async function notImportantMails() {
    loading.value = true
    await store.dispatch('mails/markAsNotImportant', {email_ids: currentRow.value, folder: tabName.value}).then((res) => {
      // loadMailData()
      window.toastr['success'](t('mail.mark_as_not_important_successfully'))
    })
  }

  async function changeMailFolder(folder, mailId=null, drag=false) {
    loading.value = true
    let ids = drag ? [mailId] : [...currentRow.value]
    await store.dispatch('mails/changeMailFolder', {email_ids: ids, folder: tabName.value, destinationFolder: folder}).then((res) => {
      loadData()
      window.toastr['success'](t('mail.change_folder_successfully'))
    }).catch(() => loading.value = false)
  }

  async function printMail() {
    const printWindow = window.open('', '', 'width=900,height=650')

    if (!printWindow) {
      return
    }

    if (currentMail.value) {
      await nextTick()

      const printContent = document.getElementById('printMailId')
      if (!printContent) {
        printWindow.document.write('<p>Erreur : contenu introuvable.</p>')
        printWindow.document.close()
        return
      }

      printWindow.document.write(`
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    }
  }

  async function deleteMail(){
    showSwal(
        '',
        t('mail.swal.deleting')
    ).then( async (result) => {
      if (result.value) {
        let res = {}
        try {
          loadingDestroy.value = true
          let data = {email_ids: currentRow.value, folder: tabName.value}

          if(showSchedule.value){
            res = await store.dispatch('mails/deleteScheduleMail', {ids: currentRow.value})
          }else{
            if(!trashFolder.value) {
              res = await store.dispatch('mails/deleteMail', data)
            }else{
              res = await store.dispatch('mails/deleteTrashMail', data)
            }
          }

          if(res){
            currentRow.value = []
            //TODO: set currentMail state
            resetCurrentMail()
            if(showSchedule.value) {
              loadScheduleMails()
            }else{
              await loadMails(1)
            }
            window.toastr['success'](i18n.global.t('mail.deleted_successfully'))
            loadingDestroy.value = false
          }
        } catch (e) {
          loadingDestroy.value = false
        }
      }
    });
  }

  function onDrop(folder) {
    changeMailFolder(folder.title, draggedMailId.value, true);
  }

  function findFolderByFolderId(folders, folderId) {
    for (const folder of folders) {
      if (folder.folder_id === folderId) return folder;
      if (folder.children && folder.children.length) {
        const found = findFolderByFolderId(folder.children, folderId);
        if (found) return found;
      }
    }
    return null;
  }

  function formatFolders(data, startIndex = 1, folder = '') {
    return data.map((item, index) => ({
      id: startIndex + index,
      folder_id: item.path || item.folder,
      isDirectory: !!item.path.length,
      count: item.total_emails,
      title: item.folder,
      name: folder ? encodeURI(folder + '/' + item.folder) : item.folder,
      children: item.children ? formatFolders(item.children, startIndex + index + 1, folder ? folder + '/' + item.folder : item.folder) : []
    }));
  }

  function setTab(value) {
    tab.value = value
  }

  function loadUseSearch() {
    if(search.value){
      loadMails(1)
      currentRow.value = []
      //TODO: set currentMail state
      resetCurrentMail()
    }
  }

  function handleDoubleClick(detail) {
    if(draftFolder.value) {
      performAction({ action: mailActions.EDIT })
    }else{
      if (currentMail.value?.id !== detail.id) {
        detailData(detail)
      }

      hideTable.value = true
      large.value = false
    }
  }

  async function detailData(detail) {
    isDetailLoading.value = true
    showDetail.value = true
    if (currentMail.value?.id === detail.id) {
      //TODO: set currentMail state
      return
    }

    scrollToBottom()

    if(folder.value === 'schedule'){
      await store.dispatch('mails/getScheduleMail', detail.id)
          .finally(() => isDetailLoading.value = false)
    }else{
      await store.dispatch('mails/getMail', {folder: folder.value, uid: detail.id})
          .finally(() => isDetailLoading.value = false)
    }

    if (!detail.isSeen) {
      detail.isSeen = true

      await store.dispatch('mails/markAsRead', {
        email_ids: [detail.id],
        folder: tabName.value
      }).then(() => {
        addOrRemoveCount(false)
        store.dispatch('mails/loadUnseenMailCount')
      })
    }
  }

  function addOrRemoveCount(add) {
    let folder = Object.values(folders.value).find((value) => value.folder_id == tab.value);
    if (folder && folder.count >= 0) {
      folder.count = add ? folder.count + 1 : folder.count - 1;
    }
  }

  function scrollToBottom() {
    const scrollHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    window.scrollTo({
      top: scrollHeight,
      behavior: 'smooth'
    });
  }

  function setLarge(){
    large.value = !large.value
  }

  function setHideTable(hide) {
    if(Object.values(currentMail.value).length) hideTable.value = hide
    currentRow.value = []
    //TODO: set currentMail state
    resetCurrentMail()
    showDetail.value = false
    large.value = false
  }

  function openMessageComponent(){
    const url = router.resolve({
      name: 'mail-create',
      query: { tab: route.query.tab }
    }).href

    windowMail.value = $openInAnotherWindow(url)
  }


  function getReplyMessage(data) {
    let senderName = data.from?.personal ? data.from?.personal : data.from?.mail
    let message = "<br/> <br/>";
    message = message + 'Le ' + $formatDateTime(new Date(data.date)) + ', ' + senderName + ' a écrit :'
    if(data.body_html) {
      message = message + "<blockquote class='blockquote-style' style='padding-left:5px; border-left:#1010ff 2px solid; margin-left:5px; width:100%'>" + extractHtmlContent(data.body_html) + "</blockquote>"
      return message
    }

    if(data.body_text) {
      message = message + "<blockquote class='blockquote-style' style='padding-left:5px; border-left:#1010ff 2px solid; margin-left:5px; width:100%'>" + data.body_text + "</blockquote>"
      return message
    }
    return message
  }

  function extractHtmlContent(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(transformDivsWithInlineStylesToFigures(htmlString), "text/html");
    const styleTags = doc.querySelectorAll('style');
    styleTags.forEach(styleTag => {
      styleTag.parentNode.removeChild(styleTag);
    });
    return doc.documentElement.innerHTML;
  }

  function transformDivsWithInlineStylesToFigures(html) {
    if (!html) return html;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const divs = doc.querySelectorAll('div[style] > img');

    divs.forEach(img => {
      const div = img.parentElement;
      if (!div) return;

      const figure = doc.createElement('figure');
      let figureClasses = ['image'];

      const style = div.getAttribute('style') || '';

      if (style.includes('float:left')) {
        figureClasses.push('image-style-align-left');
      } else if (style.includes('float:right')) {
        figureClasses.push('image-style-align-right');
      } else if (style.includes('margin:0 auto') || style.includes('text-align:center')) {
        figureClasses.push('image-style-align-center');
      }

      const widthMatch = style.match(/width:\s*([0-9.]+%|[0-9]+px)/i);
      if (widthMatch) {
        figure.setAttribute('style', `width:${widthMatch[1]};`);
      }

      img.removeAttribute('style');
      figure.appendChild(img.cloneNode(true));

      let nextSibling = div.nextElementSibling;
      if (nextSibling && nextSibling.tagName.toLowerCase() === 'div') {
        const text = nextSibling.textContent.trim();
        const styleCaption = nextSibling.getAttribute('style') || '';
        if (text && styleCaption.includes('text-align:center')) {
          const figcaption = doc.createElement('figcaption');
          figcaption.textContent = text;
          figure.appendChild(figcaption);
          nextSibling.remove();
        }
      }

      figure.setAttribute('class', figureClasses.join(' '));

      div.parentNode.replaceChild(figure, div);
    });

    return doc.body.innerHTML;
  }


  function loadFolders() {
    store.dispatch('folders/loadFolders')
  }

  async function  loadMails(page) {
    if(tabName.value) {
      loading.value = true
      await store.dispatch('mails/loadMails', {folder: tabName.value, page: page, search: search.value, orderBy: query.value.sortBy.sort, filter: query.value.filter}).then(() => loading.value = false)
      store.dispatch('mails/loadUnseenMailCount')
    }
  }

  function goToPreviousPage() {
    if (mails.value.current_page > 1) {
      loadMails(parseInt(mails.value.current_page) - 1);
      currentRow.value = []
      //TODO: set currentMail state
      resetCurrentMail()
    }
  }

  function goToNextPage() {
    if (mails.value.current_page < mails.value.last_page) {
      loadMails(parseInt(mails.value.current_page) + 1);
      currentRow.value = []
      //TODO: set currentMail state
    }
  }

  function goToFirstPage() {
    if (mails.value.current_page > 1) {
      loadMails(1);
      currentRow.value = []
      //TODO: set currentMail state
      resetCurrentMail()
    }
  }

  function goToLastPage() {
    if (mails.value.current_page < mails.value.last_page) {
      loadMails(mails.value.last_page);
      currentRow.value = []
      //TODO: set currentMail state
      resetCurrentMail()
    }
  }

  function loadData() {
    //search.value = ''
    loadMails(1)
    loadScheduleMails()
    currentRow.value = []
    //TODO: set currentMail state
    resetCurrentMail()
    large.value = false
    hideTable.value = false
  }

  function getLoading(loading) {
    loadingTransfer.value = loading
  }

  function getUpdateLoading(loading) {
    loadingUpdate.value = loading
  }

  function getReplyLoading(loading) {
    loadingReplyAll.value = loading
  }

  function showDisplayedContent() {
    missingConfig.value = false
    hideContent.value = false
  }
  function hideDisplayedContent() {
    hideContent.value = true
  }
  function toggleConfigModal() {
    $('#create_user_imap_modal').modal('toggle')
  }

  function loadScheduleMails() {
    store.dispatch("mails/loadScheduleMails")
  }

  function loadAllData() {
    store.dispatch("user/getCurrentUser")
    store.dispatch("mails/loadUsersAndContacts")
    store.dispatch("mails/loadPriorities")
    loadScheduleMails()
    loadFolders()
    if(folders.value.length > 0) tab.value = 1
  }

  async function logoutMail(){
    showSwal(
      '',
      t('mail.swal.logout'),
      'info',
      '#0072CE'
    ).then( async (result) => {
      if (result.value) {
        let res = {}
        try {
          loadingLogout.value = true
          res = await store.dispatch('mails/logoutMail')

          if(res){
            window.toastr['success'](i18n.global.t('notification.logout_successfully'))
            router.go(0);
            loadingLogout.value = false
          }
        } catch (e) {
          loadingLogout.value = false
        }
      }
    });
  }

  async function saveDraft(data) {
    try {
      await store.dispatch('mails/createMail', data)
      await store.dispatch('mails/loadMails', {folder: data.folder, page: 1})
      currentRow.value = []
      //TODO: set currentMail state
      await resetCurrentMail()
      large.value = false
      hideTable.value = false
    } catch (e) {
      console.error("Erreur lors de la sauvegarde du brouillon :", e)
    }
  }

  function isContentOnlySignature(content, sign) {
    let contentWithoutSign = content.replace(sign, '');
    contentWithoutSign = contentWithoutSign.replace(/<[^>]*>/g, '');
    contentWithoutSign = contentWithoutSign.replace(/&nbsp;|\s|\u00A0/g, '');
    return contentWithoutSign.length === 0;
  }

  onMounted(async() => {
    await store.dispatch("projects/loadProjectsCollection")

    $('.kt_select2').select2();

    if(window.Echo){
      window.Echo.channel(`New.Mail`)
          .listen('.Core\\v1\\WebMail\\Events\\NewWebMailMessage',async (e) => {
            store.commit('mails/ADD_MAIL', e)
            await store.dispatch('mails/loadUnseenMailCount')
          })
      ;
    }

    await store.dispatch('mails/getUserConfig')

    await store.dispatch('mails/getImapConfig').then(async(res) => {
      if(!!res.data.incoming && !!res.data.outgoing){
        await store.dispatch('mails/getUserConfig').then((res) => {
          if(res.data.data){
            loadAllData()
          }else{
            missingConfig.value = true
            $('#create_user_imap_modal').modal('toggle')
          }
        })
      }else{
        showSwal(
          t('mail.swal.warning'),
          t('mail.swal.config_imap'),
          'info',
          "rgba(0, 114, 206, 1)"
        ).then( async (result) => {
          if (result.value) {
            await router.push({name: 'settings-imap'})
          }
        });
      }
    })

    window.onChildWindowClose = (data) => {
      if(!isContentOnlySignature(data.message, activeSignature.value)) {
        saveDraft(data)
      }
    };

  })
</script>

<style scoped>
  .dropdown-toggle::after {
    display: none !important;
  }

  .custom-checkbox {
    appearance: none;
    width: 15px;
    height: 15px;
    background-color: var(--bs-light-primary);
    border-radius: 4px;
    cursor: pointer;
    position: relative;
  }

  .custom-checkbox:checked {
    background-color: var(--bs-primary);
  }

  .custom-checkbox:checked::after {
    content: '✔';
    color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }

  .custom-radio {
    appearance: none;
    width: 13px;
    height: 13px;
    background-color: var(--bs-light-primary);
    border-radius: 50%;
    cursor: pointer;
    position: relative;
  }

  .text-light-primary {
    color: var(--bs-light-primary) !important;
  }

  .custom-radio:checked {
    background-color: var(--bs-primary);
  }

  .custom-radio:checked::after {
    content: '';
    color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }

  .active_tr {
    margin: 10px 50px !important;
    font-weight: 600 !important;
  }

  .selected_tr {
    background-color: var(--bs-light-primary);
    margin: 10px 50px !important;
  }

  .spinner-overlay {
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 6px solid #f3f3f3;
    border-top: 5px solid var(--bs-primary);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
    margin-left: 48%;
    margin-top: 5%;
    margin-bottom: 10px;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .active_tab {
    background-color: var(--bs-light-primary);
    border-radius: 5px;
  }

  .button {
    position: relative;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
    padding-block: 0.5rem;
    padding-inline: 1.25rem;
    background-color: var(--bs-primary);
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #ffff;
    gap: 10px;
    font-weight: bold;
    border: 3px solid #ffffff4d;
    outline: none;
    overflow: hidden;
    font-size: 15px;
  }

  .icon {
    width: 24px;
    height: 24px;
    transition: all 0.3s ease-in-out;
  }

  .button:hover {
    transform: scale(1.05);
    border-color: #fff9;
  }

  .button:hover .icon {
    transform: translate(4px);
  }

  .button:hover::before {
    animation: shine 1.5s ease-out infinite;
  }

  .button::before {
    content: "";
    position: absolute;
    width: 100px;
    height: 100%;
    background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0) 70%
    );
    top: 0;
    left: -100px;
    opacity: 0.6;
  }

  @keyframes shine {
    0% {
      left: -100px;
    }

    60% {
      left: 100%;
    }

    to {
      left: 100%;
    }
  }

  .folder:hover {
    background-color: var(--bs-light-primary) !important;
    border-radius: 5px;
  }
</style>
